import React, { useState, useRef } from 'react';

const MaskedInput = ({
  value = '',
  timeout = 1000,
  mask = '•',
  show = false,
  type = 'text',
  onChange,
  ...props
}) => {
  const [unmasked, setUnmasked] = useState(value);
  const [maskedValue, setMaskedValue] = useState(Array(value.length + 1).join(mask));
  const inputRef = useRef(null);
  const timerRef = useRef(null);

  const handleChange = (ev) => {
    clearTimeout(timerRef.current);

    const cursorPos = inputRef.current.selectionEnd;
    const newValue = ev.target.value;
    
    const updatedUnmasked = newValue.replace(new RegExp(`${cursorPos ? `(^\\${mask}{1,${cursorPos}})|` : '' }(\\${mask}+)`, 'g'), 
      (match, part, offset) => {
        if (!offset && cursorPos) return unmasked.substr(0, match.length);
        return unmasked.substr(-match.length);
      }
    );

    const masked = newValue
      .split('')
      .map((c, index) => (index === cursorPos - 1 ? c : mask))
      .join('');

    setMaskedValue(masked);
    setUnmasked(updatedUnmasked);

    if (onChange) onChange(updatedUnmasked);

    inputRef.current.selectionStart = cursorPos;
    inputRef.current.selectionEnd = cursorPos;

    timerRef.current = setTimeout(() => {
      const start = inputRef.current.selectionStart;
      const end = inputRef.current.selectionEnd;

      setMaskedValue(Array(updatedUnmasked.length + 1).join(mask));

      inputRef.current.selectionStart = start;
      inputRef.current.selectionEnd = end;
    }, timeout);
  };

  return (
    <input
      {...props}
      ref={inputRef}
      type={type}
      value={show ? unmasked : maskedValue}
      onChange={handleChange}
    />
  );
};

export default MaskedInput;
